import 'babel-polyfill'
import React from 'react'
import { render } from 'react-dom'
import { Provider } from 'react-redux'
import { AppContainer } from 'react-hot-loader'
import { I18nextProvider } from 'react-i18next'
import 'react-hot-loader/patch'
import 'timeout-bedrock/_lib/bedrock.scss'
import './index.css'
import i18n from './i18n'

import configureStore from './store/configure-store'
import App from './app'

const initialState = window.__INITIAL_STATE__ // eslint-disable-line no-underscore-dangle
const store = configureStore(initialState)

function bootstrap() {
  render(
    <I18nextProvider i18n={i18n}>
      <AppContainer>
        <Provider store={store}>
          <App />
        </Provider>
      </AppContainer>
    </I18nextProvider>,
    document.getElementById('root'),
  )
}

if (!window.Raven) {
  bootstrap()
} else {
  /* global Raven */
  window.Raven.context(() => {
    bootstrap()
  })
}

if (module.hot) {
  module.hot.accept('./app', bootstrap)
}



// WEBPACK FOOTER //
// ./src/index.js